export const educationData = [
    {
        id: 1,
        institution: 'MASAI SCHOOL, BANGALORE',
        course: 'Full Stack Web Development',
        startYear: '2021',
        endYear: 'Present'
    },
    {
        id: 2,
        institution: 'Aditya Silver Oak Institute of Technology',
        course: "Bachelor of Chemical Engineering",
        startYear: '2015',
        endYear: '2019'
    },
   
]